import { useMemo } from 'react'
import type { Location } from 'history'
import { useAppSelector } from 'hooks/reduxHooks'
import { isCorporateEventsHostname } from 'corporateEvents/utils/corporateEventsRoutes'

export function useCorporateEventsTransformedLocation(
  location: Location,
): Location {
  const hostname = useAppSelector((state) => state.system.hostname)

  return useMemo(() => {
    if (!isCorporateEventsHostname(hostname)) return location

    const pathname = location.pathname
    const match = pathname.match(/^\/([a-z]{2})\/corporate-events(.*)$/)
    if (match) {
      return {
        ...location,
        pathname: match[2] || '/',
      }
    }

    return location
  }, [location, hostname])
}
